import * as React from "react";

import "./month-year-panel.scss";

import {Select}      from "@Common/ui-components/heavy/common/design2/select/select";
import {createArray} from "@Common/utils/collections";
import {addMonth}    from "@Common/utils/date-object";

export const MonthYearPanel = (
    {
        minMonthYear={year: new Date().getFullYear(), month: 1},
        maxMonthYear={year: new Date().getFullYear() + 1, month: 12},
        monthYear,
    }
) => (
    <div className="month-year-panel-hd5">
        <div className="left">
            <div className="month-dropdown">
                {Select({
                    list: createArray(12).map(v=>v+1)
                        .filter((m) => isValidMY({month: m, year: monthYear.value.year}, {min: minMonthYear, max: maxMonthYear}))
                    ,
                    itemToLabel: m => months[m-1],
                    onChange: (month) => monthYear.onChange({month, year: monthYear.value.year}),
                    isSelected: (month) => month === monthYear.value.month,
                    forcedExpandLeft: true,
                    xdQaName: "Month",
                    style: {
                        height: 26,
                    },
                })}
            </div>
            <div className="year-dropdown">
                {Select({
                    list: createArray(20).map(v=>new Date().getFullYear() - 10 + v).filter((y) => (
                        createArray(12).map(v=>v+1).find((m) => isValidMY({month: m, year: y}, {min: minMonthYear, max: maxMonthYear}))
                    )),
                    itemToLabel: y => y,
                    onChange: (y) => {
                        const newMY = {month: monthYear.value.month, year: y};
                        if (isValidMY(newMY, {min: minMonthYear, max: maxMonthYear})) {
                            monthYear.onChange(newMY);
                        } else {
                            monthYear.onChange({
                                month: createArray(12).map(v=>v+1).find((m) => isValidMY({month: m, year: y}, {min: minMonthYear, max: maxMonthYear})),
                                year: y,
                            });
                        }
                    },
                    isSelected: (y) => y === monthYear.value.year,
                    forcedExpandLeft: true,
                    xdQaName: "Year",
                    style: {
                        height: 26,
                    }
                })}
            </div>
        </div>

        <div className="right">
            {(() => {
                const newValue = addMonth(monthYear.value, -1);
                return (
                    <button
                        disabled={newValue.year < minMonthYear.year || (newValue.year === minMonthYear.year && newValue.month < minMonthYear.month)}
                        onClick={() => monthYear.onChange(newValue)}
                        xd-qa-type="button"
                        xd-qa-name="Month Decrement"
                    >
                        <i className="fa fa-chevron-left"/>
                    </button>
                );
            })()}
            {(() => {
                const newValue = addMonth(monthYear.value, 1);
                return (
                    <button
                        disabled={newValue.year > maxMonthYear.year || (newValue.year === maxMonthYear.year && newValue.month > maxMonthYear.month)}
                        onClick={() => monthYear.onChange(newValue)}
                        xd-qa-type="button"
                        xd-qa-name="Month Increment"
                    >
                        <i className="fa fa-chevron-right"/>
                    </button>
                );
            })()}
        </div>
    </div>
);

const isValidMY = (my, {min, max}) => {
    if (min && gt(min, my)) {
        return false;
    }
    if (max && gt(my, max)) {
        return false;
    }
    return true;
};

const gt = (my1, my2) => {
    if (my1.year !== my2.year) {
        return my1.year > my2.year;
    }
    return my1.month > my2.month;
};

const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];